const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

const BASE_URL = isLocalhost
  ? window.location.origin
  : `${window.location.protocol}//${window.location.hostname}`;

const isSimplifiedTradeActive = localStorage.getItem('isSimplifiedTradeActive') ?? 'true';

export const config = {
  axiosTimeout: 10000, // in miliseconds
  coinflareUrl: BASE_URL,
  careersUrl: 'https://www.linkedin.com/company/coinflareglobal/jobs',
  blogUrl: `${BASE_URL}/blog`,
  feeStructureUrl:
    'https://help.coinflare.com/hc/en-us/articles/6316329212953-What-are-Trading-Fees-Maker-Fee-Taker-Fee-etc-',
  apiDocumentationUrl: 'https://docs.coinflare.com/',
  helpCenterUrl: 'https://help.coinflare.com/hc/en-us',
  announcementsUrl: `${BASE_URL}/notification-center/announcements`,
  notificationsUrl: `${BASE_URL}/notification-center/notifications`,
  notificationCenterUrl: `${BASE_URL}/notification-center`,
  derivativesUrl:
    isSimplifiedTradeActive === 'true'
      ? `${BASE_URL}/trade-contract`
      : `${BASE_URL}/trade/contract`,
  earnUrl: `${BASE_URL}/earn`,
  p2pUrl: `${BASE_URL}/p2p/trade`,
  spotUrl: isSimplifiedTradeActive === 'true' ? `${BASE_URL}/trade-spot` : `${BASE_URL}/trade/spot`,
  campaignsUrl: `${BASE_URL}/campaign`,
  rewardsHubUrl: `${BASE_URL}/rewards`,
  vipProgramUrl: `${BASE_URL}/vip`,
  feedbackUrl: 'https://help.coinflare.com/hc/en-us/requests/new',
  depositUrl: `${BASE_URL}/assets/spot/deposit`,
  withdrawUrl: `${BASE_URL}/assets/spot/withdraw`,
  affiliateAgreementUrl:
    'https://help.coinflare.com/hc/en-us/articles/16105224968345-Bitflex-Affiliate-Agreement',
  referralAgreementUrl:
    'https://help.coinflare.com/hc/en-us/articles/12570728079385-Introduction-to-BITFLEX-Referral-Programme',
  privacyPolicyUrl:
    'https://help.coinflare.com/hc/en-us/articles/6344223252121-Bitflex-Privacy-Policy',
  howToCompleteKYC: `https://help.coinflare.com/hc/en-us/articles/6314895494297-How-Do-I-Complete-KYC-Verification-`,
  jobOpeningsUrl: 'https://www.linkedin.com/company/coinflareglobal/jobs/',
  legalStatementUrl:
    'https://help.coinflare.com/hc/en-us/articles/6343551009177-Bitflex-Legal-Statement',
  convertUrl: `${BASE_URL}/convert`,
  referralUrl: `${BASE_URL}/referral`,
  affiliateUrl: `${BASE_URL}/affiliate`,
  mediaKitUrl: `${BASE_URL}/media-kit`,

  coinflareAppDownloadUrl: `${BASE_URL}/download-app`,
  iosTestflightUrl: 'https://scanqr.to/6d0e0b3f',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=com.bitflexltd.app&pli=1',
  androidApkUrl: 'https://static1.coinflare.com/app/android/bitflex-release.apk',

  googleAuthenticatorIosAppUrl: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
  googleAuthenticatorAndroidAppUrl:
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pli=1',

  twitterUrl: 'https://x.com/CoinflareGlobal',
  // facebookUrl: 'https://www.facebook.com/bitflex.global',
  // instagramUrl: 'https://www.instagram.com/bitflex',
  linkedinUrl: 'https://www.linkedin.com/company/coinflareglobal',
  telegramUrl: 'https://t.me/coinflare_global',
  // mediumUrl: 'https://medium.com/@bitflex',
  // discordUrl: 'https://discord.com/invite/HZwaJ2jN3z',
  zendeskEarnUrl:
    'https://help.coinflare.com/hc/en-us/articles/17086701115801-Coinflare-Earn-Terms-and-Conditions',
  conversionHistoryUrl: `${BASE_URL}/convert/history`,
  f2cMoreUrl:
    'https://help.coinflare.com/hc/en-us/articles/16746935811993-FAQs-Buy-Crypto-via-Third-Party-Payment-Gateways-',
  currentYear: new Date().getFullYear(),
};
